import { useState } from "react";
import type { Episode } from "@/types/media";

interface EpisodeListProps {
  episodes: Episode[];
}

export default function EpisodeList({ episodes }: EpisodeListProps) {
  const [selectedId, setSelectedId] = useState(episodes[0]?.id ?? 1);
  const [expanded, setExpanded] = useState(false);

  const current = episodes.find((episode) => episode.id === selectedId) ?? episodes[0];
  const visible = expanded ? episodes : episodes.slice(0, 4);

  if (!episodes.length) return null;

  return (
    <section className="rounded-lg border border-background-800 bg-background-900/50 p-5 md:p-6" aria-label="剧集目录">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-50 md:text-xl">
          <i className="ri-list-check-2 text-accent-400"></i>
          剧集目录
          <span className="text-sm font-normal text-foreground-400">共 {episodes.length} 集</span>
        </h2>
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="flex items-center gap-1 text-sm text-secondary-300 transition-colors hover:text-accent-400 md:hidden"
        >
          {expanded ? "收起" : "展开全部"}
          <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
        </button>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2.5 sm:grid-cols-3 md:grid-cols-4">
        {visible.map((episode) => {
          const active = episode.id === selectedId;
          return (
            <button
              key={episode.id}
              type="button"
              onClick={() => setSelectedId(episode.id)}
              aria-pressed={active}
              className={`truncate rounded-md border px-3 py-2.5 text-left text-sm transition-colors ${
                active
                  ? "border-accent-500 bg-accent-500/15 text-accent-300"
                  : "border-background-700 bg-background-800/50 text-foreground-300 hover:border-secondary-500 hover:text-foreground-100"
              }`}
            >
              {episode.title}
            </button>
          );
        })}
      </div>

      {current && (
        <div className="mt-4 rounded-md border border-background-800 bg-background-950/60 p-4">
          <h3 className="font-heading text-sm font-semibold text-foreground-100">{current.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-400">{current.synopsis}</p>
        </div>
      )}
    </section>
  );
}